module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Ga-Ha-Ib-Ja.5ce9839c.png";